import { memo } from 'react';

import { logger } from '#utils/logging/logger';

import type { BoardData } from '../../../../pages/[[...board]]';

import { BoardSectionTileCategoryLeft1 } from './Tiles/BoardSectionTileCategoryLeft1';
import { BoardSectionTileCategoryLeft2 } from './Tiles/BoardSectionTileCategoryLeft2';
import { BoardSectionTileCategoryRight1 } from './Tiles/BoardSectionTileCategoryRight1';
import { BoardSectionTileCategoryRight2 } from './Tiles/BoardSectionTileCategoryRight2';
import { BoardSectionTileRaised2 } from './Tiles/BoardSectionTileRaised2';
import { BoardSectionTileRaisedRight2Weather } from './Tiles/BoardSectionTileRaisedRight2Weather';
import { BoardSectionTileRegional4 } from './Tiles/BoardSectionTileRegional4';
import { BoardSectionTileShortnewsRight1 } from './Tiles/BoardSectionTileShortnewsRight1';
import { BoardSectionTileShortnewsRight2 } from './Tiles/BoardSectionTileShortnewsRight2';
import { BoardSectionTileSmall3 } from './Tiles/BoardSectionTileSmall3';
import { BoardSectionTileSmall3Highlight } from './Tiles/BoardSectionTileSmall3Highlight';
import { BoardSectionTileSubjectsNewsWeather } from './Tiles/BoardSectionTileSubjectsNewsWeather';

type Props = {
	boardSection: BoardData['sections'][number];
};

export const BoardSectionTile = memo(({ boardSection }: Props) => {
	switch (boardSection.schema) {
		case 'SMALL_3':
			return <BoardSectionTileSmall3 boardSectionItems={boardSection.items} />;

		case 'HIGHLIGHT_3':
			return <BoardSectionTileSmall3Highlight boardSectionItems={boardSection.items} />;

		case 'RAISED_LEFT_SIMPLE':
			return <BoardSectionTileRaised2 boardSectionItems={boardSection.items} raised="left" />;

		case 'RAISED_RIGHT_SIMPLE':
			return <BoardSectionTileRaised2 boardSectionItems={boardSection.items} raised="right" />;

		case 'CATEGORY_LEFT_1_BIG':
			return <BoardSectionTileCategoryLeft1 boardSectionItems={boardSection.items} />;

		case 'CATEGORY_LEFT_2_SMALL':
			return <BoardSectionTileCategoryLeft2 boardSectionItems={boardSection.items} />;

		case 'CATEGORY_RIGHT_1_BIG':
			return <BoardSectionTileCategoryRight1 boardSectionItems={boardSection.items} />;

		case 'CATEGORY_RIGHT_2_SMALL':
			return <BoardSectionTileCategoryRight2 boardSectionItems={boardSection.items} />;

		case 'RAISED_RIGHT_SHORTNEWS':
			return <BoardSectionTileShortnewsRight1 boardSectionItems={boardSection.items} />;

		case 'RAISED_RIGHT_SHORTNEWS_2_SMALL':
			return <BoardSectionTileShortnewsRight2 boardSectionItems={boardSection.items} />;

		case 'REGIONAL_4_SIMPLE':
			return <BoardSectionTileRegional4 section={boardSection} />;

		case 'RAISED_RIGHT_SIMPLE_WEATHER':
			return <BoardSectionTileRaisedRight2Weather section={boardSection} />;

		case 'SUBJECTS_NEWS_WEATHER':
			return <BoardSectionTileSubjectsNewsWeather section={boardSection} />;

		default:
			logger.error(`Unknown 'BoardSectionSchema' used: '%s'. RowId: '%s'`, (boardSection as any).schema, (boardSection as any).rowId);

			return null;
	}
});

BoardSectionTile.displayName = 'BoardSectionTile';
